import styled from 'styled-components';

import { Div } from 'common/styles/oc-styled-components';
import { BREAKPOINTS, colors } from 'common/styles/style-constants';

export const ProfileName = styled(Div)`
  color: ${colors.charcoal};
  font-size: 35px;
  font-weight: 600;
  margin: 0 0 5px 0;

  @media (max-width: ${BREAKPOINTS.tabletMax}px) {
    font-size: 30px;
  }
`;

export const AddressLine = styled(Div)`
  color: ${colors.charcoal};
  font-size: 18px;
`;
